__turbopack_context__.v({
  "card": "LoadingCard-module__rwcvca__card",
  "loadingCards": "LoadingCard-module__rwcvca__loadingCards",
});
